import {
  bookingMeetingFuc,
  cancerMeetingFuc,
  findUsersByDeptCode,
  getAllDeptment,
  getAllUserBySearch,
  getCalenderDataFuc,
  getExternal,
  getHolidayInfo,
  getRoomDetail,
  getUserList,
  getZoneTreeData,
  saveExternalFuc,
  sendMeetingNotice
} from '../services/calender';
import { routerRedux } from 'dva/router';
import { Base64 } from 'js-base64';
import _ from 'lodash';
import moment from 'moment';
import openDialog from '../components/commons/ScheduleDialog';
import PromptInfo from '../utils/promptInfo.js';
import { Modal } from 'antd';
import { CALENDAR_TIME_TYPE, MEETING_AUDIT, PATHS, ROOM_CAPACITY, SEMICOLON } from '../utils/constants';

let initialFilter = {
  roomName: '',
  type: 2,
  zoneIds: '',
  roomIds: '',
  deviceIds: '',
  peopleNum: 1,
  teaIds: '',
  pageNo: 1,
  pageSize: 100000
};

const DialogType = PromptInfo.DialogType;

export default {
  namespace: 'meeting',
  state: {
    allDeptData: {},
    calenderMeetingData: {},
    meetingTreeData: {},
    showTime: null,
    externalData: null,
    userListData: null,
    allRoomList: null,
    userByDept: null,
    roomDevices: [], //会议室绑定的固定设备
    holidays: [],
    timeType: CALENDAR_TIME_TYPE.week,
    searchInfo: _.clone(initialFilter)
  },
  reducers: {
    calenderMeetingData(state, data) {
      return { ...state, calenderMeetingData: data.data || null };
    },
    meetingTreeData(state, data) {
      return { ...state, meetingTreeData: data.data || null };
    },
    showTime(state, data) {
      return { ...state, showTime: data.data || null };
    },
    externalData(state, data) {
      return { ...state, externalData: data.data || null };
    },
    userListData(state, data) {
      return { ...state, userListData: data.data || null };
    },
    allRoomList(state, data) {
      return { ...state, allRoomList: data.data || null };
    },
    update(state, { payload }) {
      return { ...state, ...payload };
    },
    updateSearchInfo(state, {payload}) {
      state.searchInfo = {...state.searchInfo, ...payload};
      return { ...state };
    },
    setUsersByDept(state, data) {
      return { ...state, userByDept: data.userByDept || null };
    },
    changeAllDept(state, data) {
      return { ...state, allDeptData: data.allDept || null };
    }
  },
  effects: {
    * getCalenderData(filter, { call, put, select }) {
      let { searchInfo } = yield select(state => state.meeting);
      const showTime = yield select(state => state.meeting.showTime);
      const userInfo = yield select(state => state.login.userInfo);
      const locale = yield select(state => state.i18n.locale);
      searchInfo.userId = `${userInfo.userId}@${userInfo.domainName}`;
      searchInfo.startTime = showTime
        ? moment(showTime)
          .startOf('day')
          .valueOf()
        : moment()
          .startOf('day')
          .valueOf();
      searchInfo.locale = locale;
      let searchData = filter.filter;
      searchInfo = { ...searchInfo, ...searchData };
      yield put({ type: 'updateSearchInfo', payload: _.clone(searchInfo) });
      const data = yield call(getCalenderDataFuc, { ...searchInfo });
      yield put({ type: 'calenderMeetingData', data: data.data || null });
    },
    *getMeetTreeData(filter, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const searchInfo = {
        pageNo: '',
        pageSize: '',
        startTime: moment()
          .startOf('day')
          .valueOf(),
        endTime: '',
        flag: 3,
        otherRoomIds: '',
        audit: '',
        name: '',
        deviceIds: '',
        teaIds: '',
        lang: locale,
        exceptCpties: String(ROOM_CAPACITY.immediate)//预约会议时，排除即占即用会议室
      };
      let searchData = { ...filter.filter, ...{ endTime: '' } };
      const data = yield call(getZoneTreeData, {
        ...searchInfo,
        ...searchData
      });
      yield put({ type: 'meetingTreeData', data: data.data || null });
    },
    *setShowTime(timeInfo, { put }) {
      yield put({ type: 'showTime', data: timeInfo.timeInfo });
    },
    *getExternals(undefined, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const data = yield call(getExternal, locale);
      const externalData = JSON.parse(Base64.decode(data.data));
      yield put({ type: 'externalData', data: externalData });
    },
    *getUserListData(undefined, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const data = yield call(getUserList, locale);
      const userListData = JSON.parse(Base64.decode(data.data));
      yield put({ type: 'userListData', data: userListData });
    },
    *getAllMeetingRoom(undefined, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const userInfo = yield select(state => state.login.userInfo);
      const searchInfo = {
        userId: `${userInfo.userId}@${userInfo.domainName}`,
        startTime: moment()
          .startOf('day')
          .valueOf(),
        type: 2,
        zoneIds: '',
        roomIds: '',
        deviceIds: '',
        teaIds: '',
        pageNo: 1,
        pageSize: 1000,
        locale: locale,
        roomName: ''
      };
      const data = yield call(getCalenderDataFuc, { ...searchInfo });
      yield put({ type: 'allRoomList', data: data.data || null });
    },
    *bookingMeeting(
      { meeting, isReload, reType, resolve, reject },
      { call, put, select, take }
    ) {
      const { locale, messages } = yield select(state => state.i18n);
      const { data, msg, status } = yield call(bookingMeetingFuc, {
        locale,
        meeting: { meeting }
      });
      if (0 === status) {
        yield put({
          type: 'meetingInfo/getMeetingInfo',
          payload: { meetingId: data }
        });
        yield take('meetingInfo/getMeetingInfo/@@end');
        yield put({ type: 'meetingInfo/set', payload: { meetingId: data } });
        const { cmmaMeeting, meetingCtrl } = yield select(
          state => state.meetingInfo.meeting
        );
        const modalTitle =
          meeting.audit === MEETING_AUDIT.yes
            ? messages['meeting_apply_success']
            : meeting.meetingId && meeting.meetingId > 0
              ? messages['meeting_save_success']
              : messages['meeting_book_success'];
        let modalContent = null;
        if (cmmaMeeting === 1) {
          const { callNumber, joinPwd } = meetingCtrl;
          modalContent = (
            <div>
              <span style={{ color: '#999' }}>
                <span>{messages['meeting_cmma_number']}</span>：
                <span style={{ color: '#000' }}>{callNumber}</span>
              </span>
              {joinPwd !== '' && (
                <span style={{ marginLeft: '30px', color: '#999' }}>
                  <span>{messages['meeting_cmma_password']}</span>：
                  <span style={{ color: '#000' }}>{joinPwd}</span>
                </span>
              )}
            </div>
          );
        }

        Modal.success({
          title: modalTitle,
          content: modalContent,
          okText: messages['modal_manage_btn_ok']
        });
        if (isReload) {
          const reserType =
            meeting.meetingId && meeting.meetingId > 0
              ? reType
              : meeting.type > 0
                ? 1
                : 0;
          yield put(
            routerRedux.push({
              pathname: PATHS.meetingInfo,
              query: { meetingId: data, reType: reserType }
            })
          );
        }
        resolve && resolve();
      } else {
        reject && reject({msg, data, meeting, reType});
      }
      yield put({
        type: 'meetingInfo/updateBookAble',
        payload: { bookAble: true }
      });
    },
    *sendMeetingNotice({ meetingId, resolve, reject }, { call, put, take }) {
      const { msg, status } = yield call(sendMeetingNotice, meetingId);
      if (status === 0) {
        yield put({
          type: 'meetingInfo/getMeetingInfo',
          payload: { meetingId }
        });
        yield take('meetingInfo/getMeetingInfo/@@end');
        yield put({ type: 'meetingInfo/set', payload: { meetingId } });
        resolve && resolve();
      } else {
        reject && reject(msg);
      }
    },
    *cancerMeeting({ filter }, { call, put, select }) {
      const { locale, messages } = yield select(state => state.i18n);
      const userInfo = yield select(state => state.login.userInfo);
      const userId = `${userInfo.userId}@${userInfo.domainName}`;
      const data = yield call(cancerMeetingFuc, {
        meetingId: filter.meetingId,
        type: filter.type,
        userId,
        locale
      });
      if (data.status) {
        Modal.success({
          content: data.msg,
          okText: messages['modal_manage_btn_ok']
        });
      } else {
        Modal.success({
          content: messages['meeting_cancel_success'],
          okText: messages['modal_manage_btn_ok']
        });
        yield put({ type: 'getCalenderData', filter: {} });
      }
    },
    *saveExternal(external, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const data = yield call(saveExternalFuc, external, locale);
      yield call(openDialog, {
        type: data.status ? DialogType.ERROR : DialogType.SUCCESS,
        message: data.msg,
        locale: locale
      });
      !data.status && (yield put({ type: 'getExternals' }));
    },
    *findUsersByDept({ payload }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const userByDept = yield select(state => state.meeting.userByDept);
      const data = yield call(findUsersByDeptCode, payload, locale);
      if (data.status === 0) {
        if (payload.page == 1) {
          yield put({
            type: 'setUsersByDept',
            userByDept: _.cloneDeep(data.data)
          });
        } else {
          let deptUsers = _.cloneDeep(data.data);
          if (userByDept.rows && deptUsers.rows.length > 0) {
            userByDept.page = deptUsers.page;
            deptUsers.rows.forEach(row => {
              userByDept.rows.push(row);
            });
          }
          yield put({ type: 'setUsersByDept', userByDept: userByDept });
        }
      }
    },
    *findUsersBySearch({ payload }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const userByDept = yield select(state => state.meeting.userByDept);
      const data = yield call(getAllUserBySearch, payload, locale);
      if (data.status === 0) {
        if (payload.page == 1) {
          yield put({
            type: 'setUsersByDept',
            userByDept: _.cloneDeep(data.data)
          });
        } else {
          let deptUsers = _.cloneDeep(data.data);
          if (userByDept.rows && deptUsers.rows.length > 0) {
            userByDept.page = deptUsers.page;
            deptUsers.rows.forEach(row => {
              userByDept.rows.push(row);
            });
          }
          yield put({ type: 'setUsersByDept', userByDept: userByDept });
        }
      }
    },
    *getRoomDetail({ roomId, resolve, reject }, { call, put, select }) {
      const locale = yield select(state => state.i18n.locale);
      const { data, msg, status } = yield call(getRoomDetail, {
        roomId,
        locale
      });
      if (status === 0) {
        resolve && resolve(data);
      } else {
        reject && reject(msg);
      }
    },
    *findDeptTree({}, { call, put, select }) {
      const lang = yield select(state => state.i18n.locale);
      const { status, data } = yield call(getAllDeptment, { lang });
      if (status === 1) {
        yield put({ type: 'changeAllDept', allDept: null });
      } else if (data && status === 0) {
        yield put({ type: 'changeAllDept', allDept: data });
      }
    },
    * initCalenderData(_, { select, put }) {
      const { userInfo } = yield select(state => state.login);
      const {timeType} = yield select(state => state.meeting);
      const { commonZoneIds } = userInfo;
      const commonZoneIdArr = commonZoneIds ? commonZoneIds.split(SEMICOLON) : [];
      const zoneIds = commonZoneIdArr.length > 0 ? commonZoneIdArr[commonZoneIdArr.length - 1] : '';
      let filter = {
        startTime: moment()
          .startOf('day')
          .valueOf(),
        type: timeType === CALENDAR_TIME_TYPE.day ? 1 : 2,
        roomIds: '',
        zoneIds,
        deviceIds: '',
        peopleNum: 1,
        roomName: ''
      };
      yield put({ type: 'getCalenderData', filter });
    },
    *initHolidayInfo(_, { select, put, call }) {
      const { status, data, msg } = yield call(getHolidayInfo);
      if (status === 0) {
        yield put({ type: 'update', payload: { holidays: data || [] } });
      } else {
        console.error('获取节假日信息失败', msg);
      }
    }
  },
  subscriptions: {
    set({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === PATHS.meeting || pathname === PATHS.meetingInfo) {
          dispatch({
            type: 'setShowTime',
            timeInfo: moment()
              .startOf('day')
              .locale('zh-CN')
          });
        }
        if (pathname === PATHS.meeting) {
          dispatch({ type: 'initHolidayInfo' });
          dispatch({ type: 'top/initMeetingSearchInfo' });
          dispatch({ type: 'initCalenderData' });
          dispatch({ type: 'top/getMeetingDeviceList' });
          dispatch({ type: 'meetingInfo/set', payload: { onlyVideo: 0 } });
        }
        if (pathname === PATHS.meetingInfo) {
          dispatch({ type: 'getExternals' });
          dispatch({ type: 'getUserListData' });
          dispatch({ type: 'findDeptTree' });
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/models/meeting.js